import { defineComponent as _defineComponent } from 'vue'
import CheckIcon from '~/assets/img/CheckIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'HotlistStatusSelectorPopup',
  props: {
    isHotlistActive: { type: Boolean }
  },
  emits: ["change-status"],
  setup(__props: any) {





return { __sfc: true,CheckIcon }
}

})